export * from './document'
export * from './collection'
export * from './static-mutations'
